import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

interface LogoProps {
  className?: string;
  width?: number;
  height?: number;
  alt?: string;
}

const COMPANY_FACEBOOK_URL = "https://www.facebook.com/ninetysixdigital96";

export function Logo({
  className = "",
  width = 150,
  height = 100,
  alt = "96digital Logo",
}: LogoProps) {
  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  // Ensure component is mounted to avoid hydration mismatch
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    // Return a placeholder with same dimensions to avoid layout shift
    return (
      <div
        className={`bg-muted animate-pulse rounded ${className}`}
        style={{
          width,
          height: height || "auto",
          aspectRatio: height ? `${width}/${height}` : undefined,
        }}
      />
    );
  }

  // Determine which logo to use based on resolved theme
  const isDark = resolvedTheme === "dark";
  const logoSrc = isDark ? "/96digital-logo.dark.png" : "/96digital-logo.light.png";

  return (
    <a
      href={COMPANY_FACEBOOK_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Visit 96digital on Facebook"
      className="inline-block transition-opacity hover:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 rounded"
    >
      <img
        src={logoSrc}
        alt={alt}
        width={width}
        height={height}
        className={`object-contain ${className}`}
      />
    </a>
  );
}
